module.exports = __webpack_public_path__ + "./images/2fa8a7e4a5871eb7dc799754f04c47ea.webp";